import React, { useEffect, useState, useContext }from "react";
import useCeo from "../../hooks/useCEO";
import { useUnidades } from "../../hooks/test/useUnidades";
import { SocketContext } from "../../context/SocketContext";
import Swal from "sweetalert2";
import Select from "react-select";
import { verifyJWT2 } from "../../helpers/JWT";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons.js";
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.flash.js";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import "datatables.net-responsive/js/dataTables.responsive.min.mjs";
import $ from "jquery";
import { Spinner } from "../../components/Spinner";

export const ReporteViajes = () => {

    useCeo({
        title: "ADMINISTRACIÓN DEL REPORTE DE VIAJES",
        description: "Página de administración del reporte de viajes",
    });

    const { 
        getListaCedis, 
        getReporteViajes,
        getReporteViajesAlmacenes,
        getReporteFiltroViajes,
        putReporteViaje,
    } = useUnidades();

    const { socket } = useContext(SocketContext);
    const [selectCedis, setSelectCedis] = useState([]);
    const [loading, setLoading] = useState(false);
    const [reporteViajes, setReporteViajes] = useState([]);
    const [reporteViajesFiltrado, setReporteViajesFiltrado] = useState([]);
    const timers = require('timers-promises');
    const [form, setForm] = useState({
        list_cedis: [],
    });

    useEffect(async () => {
        setLoading(true);
        ListaCedis();
        await ListaReporteViajes();
        await componentDidMount();

        setTimeout(function () {
            setLoading(false);
        }, 1000);

    }, []);

    useEffect(() => {
        if(!socket) return;
        socket.on("actualizar_reporte_viajes_", async () => {
            setLoading(true);
            await $("#Table-report-viajes").dataTable().fnDestroy();
            let res = await getReporteViajes();
            if (res.ok) {
                setReporteViajes([...res.report_viajes]);
                await componentDidMount();  
            }
            setTimeout(function () {
                setLoading(false);
            }, 1000);
            
        });
        return () => {
            socket.off('actualizar_reporte_viajes_');
        }
      }, [socket]);

    const componentDidMount = async () =>{
        // setLoading(true);
        if (!$.fn.DataTable.isDataTable("#myTable")) {
            $(document).ready(function () {
                setTimeout(function () {
                $("#Table-report-viajes").DataTable({
                    pagingType: "full_numbers",
                    pageLength: 6,
                    processing: true,
                    responsive: true,
                    dom: "Bfrtip",
                    select: {
                    style: "single",
                    },
                    language: {
                    info : "Mostrando _START_ de _TOTAL_ registros",
                    infoFiltered : '(filtrado de _MAX_ registros totales)',
                    search: "Buscar:",
                    paginate: {
                            first: "Primero",
                            last: "Último",
                            next: "Siguiente",
                            previous: "Anterior",
                        },
                    },

        
                    buttons: [
                    {
                        extend: "csv",
                        text:  "Export CSV",
                        charset: 'utf-8',
                        bom: true,
                        className: "btn btn-secondary bg-secondary"
                    },
                    ],
        
                    fnRowCallback: function (
                    nRow,
                    aData,
                    iDisplayIndex,
                    iDisplayIndexFull
                    ) {
                    var index = iDisplayIndexFull + 1;
                    $("td:first", nRow).html(index);
                    return nRow;
                    },
        
                    lengthMenu: [
                    [10, 20, 30, 50, -1],
                    [10, 20, 30, 50, "All"],
                    ],
                    columnDefs: [
                    {
                        targets: 0,
                        render: function (data, type, row, meta) {
                        return type === "export" ? meta.row + 1 : data;
                        },
                    },
                    ],
                    stateSave: true,
                    "bDestroy": true
                });
                }, 1000);
            });
        }
        // setLoading(false);
    } 
  

    const ListaReporteViajes = async () => {
        let res = await getReporteViajes();
        if (res.ok) setReporteViajes([...res.report_viajes]);
    }

    const ListaCedis = async () => {
        let resp = await getReporteViajesAlmacenes();

        if ( resp && resp.cedis_hub )
        setSelectCedis([...resp.cedis_hub]);
        
    };

    const FinalizarViaje = async (id) => {

        Swal
        .fire({
            title: "¡Seguro que deseas finalizar este viaje!",
            text: "¿Confirmar?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: "Sí",
            cancelButtonText: "Cancelar",
        })
        .then(async resultado => {
            if(resultado.value){
                let resp = await putReporteViaje(id);

                if(resp.ok){
                    console.log("linea eliminada correctamente");
                    const filtredData = reporteViajes.filter(item => item.idreport_viajes !== id);

                    console.log(filtredData);

                    await $("#Table-report-viajes").dataTable().fnDestroy();
 
                    setReporteViajes(filtredData);
                    await componentDidMount();

                    Swal.fire({
                        title: "Reporte de viaje",
                        text: "Finalizado correctamente",
                        showConfirmButton: false,
                        icon: "success",
                        timer: 1000
                    });
                    
                } else {
                    Swal.fire({
                        title: "Error",
                        text: resp.msg,
                        icon: "error",
                    });
                }
            }
        })
        
    }

    function showTable () {
        try {
            return reporteViajes.map((item, index) => {

            return (
                <tr key={index}>
                    <td className="text-xs font-weight-bold">{index +1}</td>
                    <td className="text-xs font-weight-bold">{item.cedis_hub}</td>
                    <td className="text-xs font-weight-bold">{item.unidad}</td>
                    <td className="text-xs font-weight-bold">{item.placas}</td>
                    <td className="text-xs font-weight-bold">{item.destinos}</td>
                    <td className="text-xs font-weight-bold">{item.hora_salida}</td>
                    <td className="text-xs font-weight-bold">{item.nombre_operador}</td>
                    <td className="text-xs font-weight-bold">{item.telefono_operador}</td>
                    <td className="text-xs font-weight-bold">{item.maniobra1}</td>
                    <td className="text-xs font-weight-bold">{item.telefono_maniobra1}</td>
                    <td className="text-xs font-weight-bold">
                        <button 
                            className="btn btn-outline-success"
                            onClick={ () => FinalizarViaje(item.idreport_viajes) }
                        >
                            Finalizar
                        </button>
                    </td>
                </tr>
                );
            });
        } catch (e) {
        //  alert(e.message);
        }
    };

    const filtrarViajes = async () => {
        setLoading(true);
        let hubs = []
        form.list_cedis.forEach(({label}) => {
            hubs.push(label);
        });
        console.log(hubs);

        if (hubs.length === 0) {
            Swal.fire({
                title: "Ups!",
                text: "Por favor selecciona un campo de la lista",
                icon: "info"
            });
        } else {
            let obj = {
                "cedis_hub": hubs,
            };
    
            let resp = await getReporteFiltroViajes(obj);
    
            if (resp.ok) {
                await $("#Table-report-viajes").dataTable().fnDestroy();
                await componentDidMount();
                setReporteViajes(resp.report_viajes);

                setTimeout(function () {
                    setLoading(false);
                }, 1000);

            } else{
                Swal.fire({
                    title: "Error",
                    text: resp.msg,
                    icon: "error"
                });
                setLoading(false);
            }
        }

    }

    const handleChange=e=>{
        
    }



    return (
        <>
            {loading && <Spinner />}
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-4">
                        <Select
                            options={ 
                                [{ label: "TODOS CEDIS/HUBS", value: '0'}].concat(
                                    selectCedis.map((x) => {
                                        return { value: x.consecutivo, label: x.cedis_hub };
                                    })
                                )
                            }
                            isMulti
                            className="form-control mb-4"
                            classNamePrefix={"select"}
                            value={form.list_cedis}
                            onChange={(event) => {

                                let aux = [];
                                event.forEach((label) => {
                                    aux.push(label);
                                });
                                
                                setForm({ ...form, list_cedis: aux })
                            }}
                            placeholder="Selecciona cedis"
                        />
                    </div>
                    <div className="col-2">
                        <button 
                            className="btn btn-outline-success" 
                            onClick={ filtrarViajes }
                        >
                            CONSULTAR REPORTE
                        </button>
                    </div>
                    <div className="col-12">
                        <div className="table-responsive p-0 pb-2 pt-3" style={ { fontSize: "14px" } }>
                            <table id="Table-report-viajes" className="table align-items-center justify-content-center mb-0">
                                <thead>
                                    <tr>
                                        <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">N°</th>
                                        <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">CEDIS/HUB</th>
                                        <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">UNIDAD</th>
                                        <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">PLACAS</th>
                                        <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">DESTINOS</th>
                                        <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">HORA DE SALIDA <p style={ { fontSize: "11px", margin: 0 } }></p></th>
                                        <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">OPERADOR</th>
                                        <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">TELÉFONO</th>
                                        <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">MANIOBRA</th>
                                        <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">TELÉFONO</th>
                                        <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2"></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    { showTable()}
                                </tbody>
                            </table>
                        </div>
                  </div>
                </div>
            </div>
        </>
    );
}